/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';


@Directive({
  selector: '[amwager3LegHeight]',
  standalone: true,
})
export class LegHeightDirective implements OnChanges{
  @Input() amwager3LegHeightRunnerId?: number;
  @Input() amwager3LegHeightEntries: any[] = [];

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges() {

    const raceLegsSection: Element = document.querySelector('.race-legs-section') as Element;
    const runnersSection: Element = document.querySelector('.runners-section') as Element;

    if (raceLegsSection) {
      setTimeout(() => {
        const legId: Element = raceLegsSection.querySelector(`.leg-id-${this.amwager3LegHeightRunnerId}`) as Element;

        this.renderer.setStyle(
          legId,
          'height',
          `${this.el.nativeElement.offsetHeight - .5}px`
        );

        if (this.amwager3LegHeightEntries.length === 0) return;

        for (const [key, value] of Object.entries(this.amwager3LegHeightEntries)) {

          const runnerUI = runnersSection.querySelector(`
            .runner-ui-${this.amwager3LegHeightRunnerId}-${Number(key)+1}
          `) as any;

          const legUI = raceLegsSection.querySelector(`
            .leg-ui-${this.amwager3LegHeightRunnerId}-${Number(key)+1}
          `) as Element;

          if (!runnerUI) return;

          this.renderer.setStyle(
            legUI,
            'height',
            `${runnerUI?.offsetHeight}px`
          );

        }
      }, 10);
    }

  }


}
